/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class OfferRequestOrderSmallSummaryModel extends JSONable {

  uuid: string | undefined = undefined;
  name?: string;
  numberOfShipments?: string;
  numberOfGroups?: string;
  numberOfRoutingSolutions?: string;
  progress?: string;
  pickupCities?: string;
  deliveryCities?: string;
  customerName?: string;
  // order only
  baseOfferRequestUuid?: string;
  spOrderUuid?: string;
}
